import {Flex, Text, Center, Box, Link, Button} from '@chakra-ui/react';
import router from 'next/router';
import {SubscribeSection} from '../edward8-penny/subscribe';
import {ListType} from '../../graphql/generated';
import {theme} from '../../style/theme';

export interface SoldOutFooterBarProps {
  listType: ListType;
  collectors: number;
  price: string;
  link: string;
  color: string;
  darkMode?: boolean;
}

export const SoldOutFooterBar: React.FC<SoldOutFooterBarProps> = ({
  listType,
  collectors,
  link,
  darkMode = false,
}) => {
  return (
    <Box position="relative">
      <Center
        background={darkMode ? 'black' : 'white'}
        boxShadow="0px -4px 8px rgba(0, 0, 0, 0.1)"
        position="fixed"
        bottom="0"
        width="100%"
        zIndex="banner"
        py={{base: 7, md: 2}}
        borderTopRadius={{base: '14px', md: '0px'}}
      >
        <Box>
          <Flex
            display={{base: 'none', md: 'flex'}}
            width="650px"
            justifyContent="space-between"
            alignItems="center"
          >
            <Text
              textStyle="button"
              fontSize="12px"
              lineHeight="16.8px"
              display="block"
              color={darkMode ? 'white' : 'auto'}
            >
              {collectors} existing collector{collectors !== 1 ? 's' : ''}
            </Text>
            <Flex alignItems="center">
              <Text
                textStyle="h7"
                lineHeight="22.4px"
                color={darkMode ? 'white' : 'auto'}
              >
                Initial Offering Sold Out
              </Text>
            </Flex>
            <Box px="0" width="auto">
              <Button
                colorScheme="aqua"
                onClick={() => router.push(link)}
                p="9px 26px"
              >
                <Text as="span" textStyle="h7">
                  When can I buy more pieces?
                </Text>
              </Button>
            </Box>
          </Flex>
        </Box>

        <Flex
          display={{base: 'flex', md: 'none'}}
          width="1010px"
          justifyContent="space-between"
          alignItems="center"
          px={4}
          flexDirection="column"
        >
          <Box textAlign="center">
            <Text
              textStyle="h6"
              whiteSpace="nowrap"
              color={darkMode ? 'white' : 'auto'}
            >
              Initial Offering Sold out
            </Text>
            <Text
              textStyle="body2"
              color="aqua.500"
              textAlign="left"
              mt={4}
              mb={8}
            >
              Don’t worry, you’ll be able to buy pieces from other users on the
              marketplace soon.
            </Text>
          </Box>

          <Box alignItems="center" minW={{base: '100%', md: '460px'}}>
            <SubscribeSection
              listType={listType}
              buttonText="Notify Me"
              subscribedText="Email sent! You will be the first to know when the sale is open!"
            />
          </Box>

          <Box
            width={{base: '100%', md: '20%'}}
            textAlign={{base: 'center', md: 'left'}}
          >
            <Text
              textStyle="body7"
              color="tone3"
              my={1}
              display={{base: 'block', md: 'none'}}
            >
              This will only opt you in for emails about the marketplace launch
            </Text>
            <Text fontSize="10px" color={darkMode ? 'white' : 'auto'}>
              By submitting your email address you agree to our{' '}
              <Link href="/privacy-policy" mx="2px">
                <a style={{color: theme.colors.aqua['500']}}>Privacy Policy</a>
              </Link>
              and{' '}
              <Link href="/terms-and-conditions" mx="2px">
                <a style={{color: theme.colors.aqua['500']}}>
                  Terms and Conditions
                </a>
              </Link>
              .
            </Text>
          </Box>
        </Flex>
      </Center>
    </Box>
  );
};
